import { Injectable } from '@angular/core';
import * as LDClient from 'launchdarkly-js-client-sdk';
import { BehaviorSubject } from 'rxjs';
import { validate as validateUUID } from 'uuid';

import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class LaunchDarklyService {
    readonly maintenanceModeKey =
        'feature-electronic-medical-questionnaire-app-maintenance-enabled';
    maintenanceModeSubject = new BehaviorSubject(false);

    constructor() {
        // urlのpath部のスラッシュ以降が薬局IDであると期待されるのでLDのキーとして使用する
        // location.pathnameは必ず / を含むため [1] は必ず存在する
        const path = location.pathname.split('/')[1];

        // path がUUID形式であれば薬局IDが指定されていると見做す
        const pharmacyId = validateUUID(path) ? path : 'not-selected-pharmacy-id';

        const client = LDClient.initialize(
            environment.launchDarklyClientId,
            { kind: 'user', key: pharmacyId },
        );
        client.on('ready', () => {
            this.maintenanceModeSubject.next(
                client.variation(this.maintenanceModeKey, false) as boolean,
            );
        });
    }
}
